import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"font-size":"10px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Update limits to ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Current filter: ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" State: ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_DisplayTypesButtonGroup = _resolveComponent("DisplayTypesButtonGroup")!
  const _component_CommonMap = _resolveComponent("CommonMap")!
  const _component_EventItem = _resolveComponent("EventItem")!
  const _component_Confirm = _resolveComponent("Confirm")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    ref: "listPage",
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    statistics: false,
    state: _ctx.state,
    class: _normalizeClass(["events-page", _ctx.pageClasses])
  }, _createSlots({
    filters: _withCtx(() => [
      (_ctx.debug)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.module.filter.current.limit = 20))
            }, "20"),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.module.filter.current.limit = 500))
            }, "500"),
            _hoisted_3,
            _createTextVNode(" Tab: " + _toDisplayString(_ctx.module.apiName) + ", " + _toDisplayString(_ctx.pageSidebarType) + " " + _toDisplayString(_ctx.isCurrentTab), 1),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("pre", null, "          " + _toDisplayString(_ctx.module.filter.current) + " //\n          " + _toDisplayString(_ctx.module.filter.storageKey) + "\n        ", 1),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("pre", null, "          " + _toDisplayString(_ctx.mapConfig.centerPoint) + "\n        ", 1),
            _hoisted_9,
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setTestData && _ctx.setTestData(...args)))
            }, "Set test data")
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_FilterSection, {
        filter: _ctx.module.filter,
        "scheme-small": _ctx.smallFilterLayout,
        "scheme-large": _ctx.getBigFilterLayout,
        "has-report": "",
        "has-filter-manager": "",
        "has-pinned-fields": ""
      }, {
        small: _withCtx(() => [
          _createVNode(_component_NButtonGroup, {
            items: _ctx.dataAssetsModule.eventPageTypeButtonItems,
            modelValue: _ctx.state.pageType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pageType) = $event)),
            "init-value-on-empty": ""
          }, null, 8, ["items", "modelValue"]),
          (_ctx.isEvents)
            ? (_openBlock(), _createBlock(_component_NButtonGroup, {
                key: 0,
                items: _ctx.dataAssetsModule.eventObjectTypeButtonItems,
                modelValue: _ctx.state.objectType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.objectType) = $event)),
                "init-value-on-empty": ""
              }, null, 8, ["items", "modelValue"]))
            : (_openBlock(), _createBlock(_component_NButtonGroup, {
                key: 1,
                items: _ctx.dataAssetsModule.episodeTypeButtonItems,
                modelValue: _ctx.state.episodeType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.episodeType) = $event)),
                "init-value-on-empty": ""
              }, null, 8, ["items", "modelValue"]))
        ]),
        _: 1
      }, 8, ["filter", "scheme-small", "scheme-large"])
    ]),
    statistic: _withCtx(() => [
      (!_ctx.isEvents)
        ? (_openBlock(), _createBlock(_component_Statistics, {
            key: 0,
            module: _ctx.module
          }, null, 8, ["module"]))
        : _createCommentVNode("", true),
      _hoisted_10,
      _createVNode(_component_SortDropdown, {
        items: _ctx.sortTypes,
        modelValue: _ctx.module.filter.current.ordering,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
      }, null, 8, ["items", "modelValue"]),
      _hoisted_11,
      (_ctx.acknowledgeAllAllowed)
        ? (_openBlock(), _createBlock(_component_NButton, {
            key: 1,
            type: "secondary",
            disabled: !_ctx.acknowledgeAllowed,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isAcknowledgingConfirmVisible = true)),
            class: "events-page__acknowledge-all-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.acknowledge_all', 'f')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NButton, {
        type: "secondary",
        onClick: _ctx.togglePlaying,
        class: "events-page__play-button",
        icon: _ctx.pageVM.state.playing ? 'pause' : 'play'
      }, null, 8, ["onClick", "icon"]),
      _createVNode(_component_DisplayTypesButtonGroup, {
        modelValue: _ctx.state.displayType,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.displayType) = $event)),
        "available-items": _ctx.displayTypes
      }, null, 8, ["modelValue", "available-items"])
    ]),
    items: _withCtx(() => [
      (_ctx.state.displayType === 'map')
        ? (_openBlock(), _createBlock(_component_CommonMap, {
            key: 0,
            ref: "commonMap",
            config: _ctx.mapConfig,
            trackId: _ctx.matchedCard,
            onSetFilter: _ctx.setFilter
          }, null, 8, ["config", "trackId", "onSetFilter"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.classes),
            style: {"flex-grow":"1"}
          }, [
            (_ctx.module.items.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.module.items, (item) => {
                  return (_openBlock(), _createBlock(_component_EventItem, {
                    key: item.id,
                    "data-id": item.id,
                    display: _ctx.displayItemsMap ? _ctx.displayItemsMap[item.id] : false,
                    objects: _ctx.state.objectType,
                    episodeType: _ctx.state.episodeType,
                    item: item,
                    type: _ctx.state.pageType,
                    displayType: _ctx.state.displayType,
                    defaultAction: _ctx.defaultAction,
                    "event-selected": _ctx.getIsEventOrEpisodeSelected(item),
                    "card-selected": item.matched_card && _ctx.getIsCardSelected(item.matched_card),
                    "opened-item": _ctx.getOpenedTypeByItem(item),
                    "acknowledge-allowed": _ctx.acknowledgeAllowed,
                    onSelect: () => _ctx.sidebarModule.toggleItemSelect(_ctx.pageSidebarType, item),
                    onAction: (v, p) => _ctx.actionHandler(item.id, v, { ...item, ...p })
                  }, null, 8, ["data-id", "display", "objects", "episodeType", "item", "type", "displayType", "defaultAction", "event-selected", "card-selected", "opened-item", "acknowledge-allowed", "onSelect", "onAction"]))
                }), 128))
              : _createCommentVNode("", true)
          ], 2)),
      (_ctx.isAcknowledgingConfirmVisible)
        ? (_openBlock(), _createBlock(_component_Confirm, {
            key: 2,
            description: _ctx.description,
            onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isAcknowledgingConfirmVisible = false)),
            onConfirm: _ctx.acknowledgeAllHandler
          }, null, 8, ["description", "onConfirm"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.state.displayType === 'map')
      ? {
          name: "items-empty",
          fn: _withCtx(() => [
            _hoisted_12
          ])
        }
      : undefined
  ]), 1032, ["onUpdate:scrollBottom", "state", "class"]))
}